import {
  INVOICES_RETRIEVE, CREDIT_NOTES_RETRIEVE, DEBIT_NOTES_RETRIEVE,
  REMISSION_NOTES_RETRIEVE, AUTO_INVOICES_RETRIEVE,
} from "../auth/permissions";

export const SIFEN_INCIDENT_VIEW_PERMISSIONS = [
  INVOICES_RETRIEVE, CREDIT_NOTES_RETRIEVE, DEBIT_NOTES_RETRIEVE,
  REMISSION_NOTES_RETRIEVE, AUTO_INVOICES_RETRIEVE,
];

export const incidentProgress = {
  open: "Registrada", in_progress: "En gestión", waiting_sifen: "Esperando a SIFEN",
  resolved: "Resuelta", closed: "Cerrada",
};
export const incidentDelivery = {
  queued: "Envío programado", sending: "Enviando", sent: "Correo enviado",
  failed: "Error de envío", cancelled: "Envío cancelado",
};

export interface TaxpayerSifenIncident {
  id: number;
  taxPayerId: number;
  taxPayerName: string;
  taxPayerRuc: string;
  documentNumber: string;
  cdc: string;
  issueLabel: string;
  details: string;
  progressStatus: keyof typeof incidentProgress;
  deliveryStatus: keyof typeof incidentDelivery;
  supportTicket: string | null;
  createdAt: string;
  sentAt: string | null;
  nextAttemptAt: string | null;
  canSendEmail?: boolean;
  originalMessage?: { subject: string; text: string; to?: string; cc?: string[] };
  events?: { id: number; kind: string; note: string; emailHtml?: string | null; createdAt: string }[];
}
